'use client'
import * as React from 'react'
import classes from './styles.module.css'
import {usePathname, useRouter, useSearchParams} from 'next/navigation'
import DebouncedInput from '../debounced-input/DebouncedInput'
// import searchIcon from 'common/assets/icons/search.svg'
import Image from 'next/image'

interface BlogFilterProps {
  getBlogsBySearch: any
  setSearchedBlogs: any
  setSearchText: any
  categories: any
}

const BlogFilter = ({
  getBlogsBySearch,
  setSearchedBlogs,
  setSearchText,
  categories,
}: BlogFilterProps) => {
  const exception = ['All Products', 'Most Recent']
  const params = useSearchParams()
  const pathname = usePathname()
  const router = useRouter()

  const handleSearch = (text: string) => {
    getBlogsBySearch(text)
  }

  const handleTagChange = (filter: {name: string; id: string}) => {
    const tag = params.get('tag')
    if (filter?.name === 'All' && tag !== null) {
      router.push(pathname)
    }
    if (filter?.name !== 'All' && tag !== filter?.id) {
      router.push(`${pathname}?tag=${filter?.id}`)
    }
  }
  return (
    <div className={classes.blogFilter}>
      <div className={classes.container}>
        <div className={classes.filters}>
          {[{name: 'All', id: 'all', slug: 'all'}, ...structuredClone(categories|| [])?.reverse()]
            ?.filter(category => !exception.includes(category.name))
            .map(filter => (
              <div
                key={filter.id}
                className={`${classes.filter} ${
                  params.get('tag') == filter.id ||
                  (filter.name === 'All' && params.get('tag') === null)
                    ? classes.active
                    : ''
                }`}
                onClick={() => handleTagChange(filter)}
              >
                {filter.name}
              </div>
            ))}
        </div>
        <div className={classes.search}>
          {/* <Image src={searchIcon} alt="search" width={'20'} height={'20'} /> */}
          <DebouncedInput
            onSearch={handleSearch}
            setSearchedBlogs={setSearchedBlogs}
            setSearchText={setSearchText}
          />
        </div>
      </div>
    </div>
  )
}

const BlogFilterWrapper = ({
  getBlogsBySearch,
  setSearchedBlogs,
  setSearchText,
  categories,
}: BlogFilterProps) => {
  return (
    <React.Suspense>
      <BlogFilter {...{getBlogsBySearch, setSearchedBlogs, setSearchText, categories}} />
    </React.Suspense>
  )
}

export default BlogFilterWrapper
